export default __webpack_public_path__ + "static/media/squiggle_long_lime.02bdd8ae.svg";